import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AccountOutput, entityName } from '@qtek/shared/models';

import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends HttpEntityManager<AccountOutput, any> {
  entityName: entityName = 'acn';

  constructor(protected http: HttpClient) {
    super();
  }

  updateCompany(additionalPayload: any = {}, payload: any = {}) {
    return super.put(payload, null, additionalPayload);
  }
}
